import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

export async function getTennisGames() {
  // Reference to the "games" collection
  const colRef = collection(db, 'gamesTenis');
  
  // Create a query for documents where status == "active"
  const activeQuery = query(colRef, where('status', '==', 'active'));
  
  // Execute the query
  const querySnap = await getDocs(activeQuery);

  const gamesList = [];
  querySnap.forEach((doc) => {
    gamesList.push({ id: doc.id, ...doc.data() });
  });

  return gamesList;
}